import { useState, useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft, Phone, MessageCircle, Calendar, User, Mail, Clock, Loader2, CheckCircle, AlertCircle } from 'lucide-react';

const KHOOB_API_BASE = 'https://www.khoobventures.in/api/public';

// Redirect mappings for old URLs to new canonical URLs
const REDIRECT_SLUGS = {
  'nailashes-basaveshwarnagar': '/nailashes-basaveshwarnagar/',
  'basaveshwarnagar': '/nailashes-basaveshwarnagar/',
};

const locationData = {
  'rr-nagar': {
    name: 'BLR Nail Club',
    branch: 'RR NAGAR',
    branchId: 'rr_nagar',
    logo: '/logo.png',
    logoInvert: false,
    fullAddress: 'N2VK Arcade, 1154, Jawaharlal Nehru Rd, BEML Layout 3rd Stage, Rajarajeshwari Nagar, Bengaluru, Karnataka 560098',
    phone: '+91-7204602211',
    phoneRaw: '917204602211',
    whatsapp: '917204602211',
    timings: '10:00 AM - 8:00 PM',
    days: 'Monday - Sunday',
    image: 'https://static.wixstatic.com/media/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg/v1/fill/w_1200,h_1600,al_c,q_85,enc_avif,quality_auto/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg',
    description: [
      "BLR Nail Club in RR Nagar is a premium nail and beauty studio offering expert services in nail extensions, gel polish, custom nail art, and lash extensions. Designed for a luxurious and hygienic experience, we use high-quality products and follow strict safety standards.",
      "In addition to nails and lashes, we provide advanced beauty services including PMU (permanent makeup), brow styling, and lip tinting. Our skilled technicians stay updated with the latest trends to deliver modern, long-lasting results.",
      "Conveniently located in RR Nagar, BLR Nail Club is your go-to destination for premium nail and beauty services in Bengaluru."
    ],
    services: ['Nail Extensions', 'Gel Polish', 'Nail Art', 'Lash Extensions', 'PMU Services', 'Brow Styling', 'Lip Tinting'],
    seoTitle: 'Best Nail Salon in RR Nagar | BLR Nail Club - Nail Extensions, Gel Nails, Nail Art',
    seoDescription: 'BLR Nail Club RR Nagar - Bengaluru\'s #1 nail studio. Expert nail extensions, gel nails, nail art, lash extensions & permanent makeup. Book Now! ☎ +91 72046 02211',
    seoKeywords: 'nail salon RR Nagar, best nails RR Nagar, nail extensions RR Nagar, gel nails Rajarajeshwari Nagar, nail art Bangalore, nail studio near me RR Nagar',
  },
  'nailashes-basaveshwarnagar': {
    name: 'Nailashes',
    branch: 'BASAVESHWARNAGAR',
    branchId: 'basaveshwarnagar',
    logo: '/logo.png',
    logoInvert: false,
    fullAddress: 'LGF, No. 9, East Jayanagar, West of Chord Road 1st Stage, Basaveshwar Nagar, Bengaluru, Karnataka 560079',
    phone: '+91-9611560759',
    phoneRaw: '919611560759',
    whatsapp: '919611560759',
    timings: '10:30 AM - 8:00 PM',
    days: 'Monday - Sunday',
    image: 'https://static.wixstatic.com/media/486953_3b99a1aec9184dca9d620eaa8540c766~mv2.jpeg/v1/fill/w_1200,h_1600,al_c,q_85,enc_avif,quality_auto/486953_3b99a1aec9184dca9d620eaa8540c766~mv2.jpeg',
    description: [
      "Nailashes Basaveshwarnagar offers high-quality nail and lash services in a clean, modern, and comfortable setting. We specialize in nail extensions, gel polish, creative nail art, and professional lash extensions tailored to your style.",
      "Our studio also provides PMU services such as eyebrow enhancement and lip tinting, ensuring a complete beauty experience under one roof. We focus on hygiene, precision, and customer satisfaction to deliver premium results every time.",
      "Located in Basaveshwarnagar, we are one of the top choices for nail salons in the area."
    ],
    services: ['Nail Extensions', 'Gel Polish', 'Nail Art', 'Lash Extensions', 'PMU Services', 'Eyebrow Enhancement'],
    seoTitle: 'Best Nail Salon in Basaveshwarnagar Bangalore | Nailashes - Nail Extensions, Gel Nails, Nail Art',
    seoDescription: 'Nailashes Basaveshwarnagar - Bengaluru\'s #1 nail studio in West Bangalore. Expert nail extensions, gel nails, nail art, lash extensions & PMU. Near Rajajinagar, Mahalakshmi Layout. Book Now! ☎ +91 96115 60759',
    seoKeywords: 'best nail salon Basaveshwarnagar, nail salon Basaveshwarnagar Bangalore, nails in Basaveshwarnagar, nail extensions Basaveshwarnagar, gel nails Basaveshwarnagar, nail art West Bangalore, nail studio Rajajinagar, nails near Mahalakshmi Layout, best nails West of Chord Road, nail salon near me Basaveshwarnagar, lash extensions Basaveshwarnagar, Nailashes Bangalore, nail spa Basaveshwarnagar, manicure pedicure Basaveshwarnagar, acrylic nails West Bangalore',
  },
  'benefits-rr-nagar': {
    name: 'Benefits Salon',
    branch: 'RR NAGAR',
    branchId: 'rr_nagar',
    logo: '/benefits-logo.png',
    logoInvert: true,
    fullAddress: 'RR Nagar, Bengaluru, Karnataka',
    phone: '+91-7204602211',
    phoneRaw: '917204602211',
    whatsapp: '917204602211',
    timings: '10:00 AM - 8:00 PM',
    days: 'Monday - Sunday',
    image: 'https://static.wixstatic.com/media/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg/v1/fill/w_1200,h_1600,al_c,q_85,enc_avif,quality_auto/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg',
    description: [
      "Benefits Salon RR Nagar is a full-service beauty salon offering professional hair and beauty services including haircuts, hair coloring, styling, and skincare treatments.",
      "Our experienced stylists focus on personalized consultations to deliver looks that suit your face, style, and lifestyle. We use quality products and maintain high hygiene standards to ensure a comfortable and relaxing salon experience.",
      "Whether you're looking for a fresh haircut, hair transformation, or regular grooming, Benefits Salon in RR Nagar is your trusted choice."
    ],
    services: ['Haircuts', 'Hair Coloring', 'Styling', 'Skincare Treatments', 'Facials', 'Makeup'],
    seoTitle: 'Benefits Salon RR Nagar | Hair Salon & Beauty Services in Rajarajeshwari Nagar',
    seoDescription: 'Benefits Salon RR Nagar - Professional hair salon offering haircuts, hair coloring, styling & beauty treatments. Visit us in RR Nagar, Bangalore!',
    seoKeywords: 'hair salon RR Nagar, beauty salon RR Nagar, haircut Rajarajeshwari Nagar, hair coloring Bangalore, Benefits Salon',
  },
  'benefits-basaveshwarnagar': {
    name: 'Benefits Salon',
    branch: 'BASAVESHWARNAGAR',
    branchId: 'basaveshwarnagar',
    logo: '/benefits-logo.png',
    logoInvert: true,
    fullAddress: 'Basaveshwarnagar, Bengaluru, Karnataka',
    phone: '+91-9611560759',
    phoneRaw: '919611560759',
    whatsapp: '919611560759',
    timings: '10:00 AM - 8:00 PM',
    days: 'Monday - Sunday',
    image: 'https://static.wixstatic.com/media/5df0bd_dab9ff5017f643f3bb0e5441471366df~mv2.jpeg/v1/fill/w_1200,h_1600,al_c,q_85,enc_avif,quality_auto/5df0bd_dab9ff5017f643f3bb0e5441471366df~mv2.jpeg',
    description: [
      "Benefits Salon Basaveshwarnagar is a trusted destination for professional hair and beauty services. We offer a wide range of services including haircuts, hair coloring, styling, and essential beauty treatments.",
      "Our team is trained to deliver modern styles while maintaining hair health and quality. With a focus on hygiene, customer care, and consistency, we ensure every client leaves satisfied.",
      "Conveniently located in Basaveshwarnagar, Benefits Salon is known for reliable and quality salon services."
    ],
    services: ['Haircuts', 'Hair Coloring', 'Styling', 'Beauty Treatments', 'Grooming', 'Makeup'],
    seoTitle: 'Benefits Salon Basaveshwarnagar | Hair Salon & Beauty Services in Bangalore',
    seoDescription: 'Benefits Salon Basaveshwarnagar - Professional hair salon for haircuts, coloring, styling & beauty treatments. Book your appointment now!',
    seoKeywords: 'hair salon Basaveshwarnagar, beauty salon Basaveshwarnagar, haircut Bangalore, Benefits Salon West of Chord Road',
  },
  'csk-mall': {
    name: 'BLR Nail Club',
    branch: 'CSK MALL',
    branchId: 'gunjur',
    logo: '/logo.png',
    logoInvert: false,
    fullAddress: 'Shop no 50, 1st Floor, CSK Mall, Gunjur Palya, Bengaluru, Karnataka 560087',
    phone: '+91-9741763377',
    phoneRaw: '919741763377',
    whatsapp: '919741763377',
    timings: '10:00 AM - 8:00 PM',
    days: 'Monday - Sunday',
    googleProfile: 'https://share.google/WYlU8jvsIsMtxQpaL',
    image: 'https://static.wixstatic.com/media/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg/v1/fill/w_1200,h_1600,al_c,q_85,enc_avif,quality_auto/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg',
    description: [
      "BLR Nail Club at CSK Mall, Gunjur Palya brings premium nail and beauty services to East Bangalore. Our new location offers expert services in nail extensions, gel polish, custom nail art, and lash extensions in a luxurious setting.",
      "We provide the same high-quality experience as our other locations, with skilled technicians trained in the latest nail art trends, PMU (permanent makeup), brow styling, and lip tinting services.",
      "Conveniently located on the 1st floor of CSK Mall, BLR Nail Club CSK Mall is your go-to destination for premium nail and beauty services in Gunjur Palya and surrounding areas."
    ],
    services: ['Nail Extensions', 'Gel Polish', 'Nail Art', 'Lash Extensions', 'PMU Services', 'Brow Styling', 'Lip Tinting'],
    seoTitle: 'Best Nail Salon in Varthur Sarjapur Road Gunjur | BLR Nail Club CSK Mall - Nail Extensions, Gel Nails, Nail Art',
    seoDescription: 'BLR Nail Club CSK Mall - Bengaluru\'s #1 nail studio in Gunjur, Varthur & Sarjapur Road. Expert nail extensions, gel nails, nail art, lash extensions & PMU. Near Bellandur, Whitefield. Book Now! ☎ +91 97417 63377',
    seoKeywords: 'best nail salon Gunjur, nail salon Varthur, nails in Sarjapur Road, nail extensions Gunjur Palya, gel nails Varthur, nail art Sarjapur Road Bangalore, nail studio Bellandur, nails near Whitefield, best nails East Bangalore, nail salon CSK Mall, nail salon near me Gunjur, lash extensions Varthur, BLR Nail Club Gunjur, nail spa Sarjapur, manicure pedicure Varthur, acrylic nails Whitefield, nails in Gunjur, best nail salon Sarjapur Road, nail extensions near Bellandur, gel polish Varthur Bangalore',
  },
};

const LocationDetail = () => {
  const { slug } = useParams();
  const location = locationData[slug];
  
  // Booking form state
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    staff_id: '',
    date: '',
    time: '',
  });
  
  // API data state
  const [staffList, setStaffList] = useState([]);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [bookingResult, setBookingResult] = useState(null);
  const [error, setError] = useState(null);

  // Fetch staff list when modal opens
  useEffect(() => {
    if (showBookingForm && location?.branchId) {
      fetchStaff();
    }
  }, [showBookingForm, location?.branchId]);

  // Fetch available slots when date changes
  useEffect(() => {
    if (formData.date && location?.branchId) {
      fetchAvailableSlots();
    }
  }, [formData.date, location?.branchId]);

  const fetchStaff = async () => {
    setLoadingStaff(true);
    setError(null);
    try {
      const response = await fetch(`${KHOOB_API_BASE}/staff/${location.branchId}`);
      if (response.ok) {
        const data = await response.json();
        setStaffList(data || []);
      } else {
        console.error('Failed to fetch staff');
        setStaffList([]);
      }
    } catch (err) {
      console.error('Error fetching staff:', err);
      setStaffList([]);
    } finally {
      setLoadingStaff(false);
    }
  };

  const fetchAvailableSlots = async () => {
    setLoadingSlots(true);
    setError(null);
    setAvailableSlots([]);
    setFormData(prev => ({ ...prev, time: '' }));
    try {
      const response = await fetch(`${KHOOB_API_BASE}/available-slots/${location.branchId}/${formData.date}`);
      if (response.ok) {
        const data = await response.json();
        setAvailableSlots(data.slots || []);
      } else {
        console.error('Failed to fetch slots');
        setAvailableSlots([]);
      }
    } catch (err) {
      console.error('Error fetching slots:', err);
      setAvailableSlots([]);
    } finally {
      setLoadingSlots(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setBookingResult(null);

    try {
      const response = await fetch(`${KHOOB_API_BASE}/book-appointment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email || '',
          branch: location.branchId,
          date: formData.date,
          time: formData.time,
          staff_id: formData.staff_id || '',
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setBookingResult({
          success: true,
          message: data.message,
          appointmentId: data.appointment_id,
        });
        // Reset form after successful booking
        setTimeout(() => {
          setFormData({ name: '', phone: '', email: '', staff_id: '', date: '', time: '' });
        }, 3000);
      } else {
        setBookingResult({
          success: false,
          message: data.message || data.detail || 'Failed to book appointment. Please try again.',
        });
      }
    } catch (err) {
      console.error('Booking error:', err);
      setBookingResult({
        success: false,
        message: 'Network error. Please check your connection and try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const closeModal = () => {
    setShowBookingForm(false);
    setBookingResult(null);
    setError(null);
    setFormData({ name: '', phone: '', email: '', staff_id: '', date: '', time: '' });
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  if (!location) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <h1 className="text-white text-4xl mb-4">Location Not Found</h1>
          <Link to="/about" className="text-[#B8860B] hover:underline">
            ← Back to About
          </Link>
        </div>
      </main>
    );
  }

  // Check if this slug should redirect to a new canonical URL
  if (REDIRECT_SLUGS[slug]) {
    return <Navigate to={REDIRECT_SLUGS[slug]} replace />;
  }

  const whatsappMessage = `Hi! I'd like to book an appointment at ${location.name} - ${location.branch}`;
  const whatsappUrl = `https://wa.me/${location.whatsapp}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{location.seoTitle || `${location.name} ${location.branch} | BLR Nail Club`}</title>
        <meta name="description" content={location.seoDescription || location.description[0]} />
        <meta name="keywords" content={location.seoKeywords || `nail salon ${location.branch}, beauty salon Bangalore`} />
        <link rel="canonical" href={`https://www.blrnailclub.in/location/${slug}`} />
        <meta property="og:title" content={location.seoTitle || `${location.name} ${location.branch}`} />
        <meta property="og:description" content={location.seoDescription || location.description[0]} />
        <meta property="og:url" content={`https://www.blrnailclub.in/location/${slug}`} />
        <meta property="og:type" content="business.business" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NailSalon",
            "name": `${location.name} - ${location.branch}`,
            "image": location.image,
            "url": `https://www.blrnailclub.in/location/${slug}`,
            "telephone": location.phone,
            "address": {
              "@type": "PostalAddress",
              "streetAddress": location.fullAddress,
              "addressLocality": location.branch,
              "addressRegion": "Karnataka",
              "addressCountry": "IN"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
              "opens": "10:00",
              "closes": "20:00"
            },
            "priceRange": "₹₹"
          })}
        </script>
      </Helmet>
      
    <main className="bg-black min-h-screen relative" data-testid="location-detail-page">
      {/* Full Screen Background Image */}
      <div 
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: `url(${location.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen">
        {/* Header */}
        <header className="pt-24 pb-8 px-6 md:px-12">
          <div className="max-w-5xl mx-auto">
            <Link 
              to="/about#locations" 
              className="inline-flex items-center gap-2 text-white/70 hover:text-[#B8860B] transition-colors"
              data-testid="back-to-locations"
            >
              <ArrowLeft strokeWidth={1.5} size={18} />
              <span className="text-sm tracking-[0.15em] uppercase">Back to Locations</span>
            </Link>
          </div>
        </header>

        {/* Main Content */}
        <section className="px-6 md:px-12 py-12">
          <div className="max-w-5xl mx-auto">
            {/* Location Title with Logo */}
            <div className="mb-12">
              <div className="flex items-center gap-6 mb-4">
                <img 
                  src={location.logo} 
                  alt={`${location.name} Logo`}
                  className={`h-32 md:h-40 w-auto ${location.logoInvert ? 'invert brightness-0 invert' : ''}`}
                  style={location.logoInvert ? { filter: 'invert(1) brightness(2)' } : {}}
                />
                <div>
                  <h1 className="text-white text-3xl md:text-4xl lg:text-5xl font-light tracking-wide">
                    {location.name}
                  </h1>
                  <p className="text-[#B8860B] text-base md:text-lg tracking-[0.2em] uppercase font-light">
                    {location.branch}
                  </p>
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="mb-12 space-y-6">
              {location.description.map((para, index) => (
                <p key={index} className="text-white/80 text-base md:text-lg leading-relaxed font-light">
                  {para}
                </p>
              ))}
            </div>

            {/* Contact Info */}
            <div className="mb-12 p-8 bg-black/40 backdrop-blur-sm border border-white/10">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                  <p className="text-[#B8860B] text-xs tracking-[0.2em] uppercase mb-2">Address</p>
                  <p className="text-white/90 font-light">{location.fullAddress}</p>
                </div>
                <div>
                  <p className="text-[#B8860B] text-xs tracking-[0.2em] uppercase mb-2">Timings</p>
                  <p className="text-white/90 font-light">{location.days}</p>
                  <p className="text-white font-light">{location.timings}</p>
                </div>
                <div>
                  <p className="text-[#B8860B] text-xs tracking-[0.2em] uppercase mb-2">Bookings</p>
                  <a 
                    href={`tel:${location.phoneRaw}`}
                    className="text-white text-xl font-light hover:text-[#B8860B] transition-colors flex items-center gap-2"
                  >
                    <Phone size={18} strokeWidth={1.5} />
                    {location.phone}
                  </a>
                </div>
              </div>
            </div>

            {/* Services */}
            <div className="mb-12">
              <h3 className="text-[#B8860B] text-xs tracking-[0.3em] uppercase mb-6">Services Available</h3>
              <div className="flex flex-wrap gap-3">
                {location.services.map((service, index) => (
                  <span 
                    key={index}
                    className="border border-white/20 px-4 py-2 text-white/80 text-sm tracking-[0.1em] uppercase hover:border-[#B8860B] hover:text-[#B8860B] transition-colors"
                  >
                    {service}
                  </span>
                ))}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              {/* WhatsApp Button */}
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#20BD5A] transition-colors"
                data-testid="whatsapp-button"
              >
                <MessageCircle size={20} strokeWidth={1.5} />
                Book via WhatsApp
              </a>

              {/* Booking Form Button */}
              <button
                onClick={() => setShowBookingForm(true)}
                className="flex items-center justify-center gap-3 bg-[#B8860B] text-black px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#9A7B0A] transition-colors"
                data-testid="booking-form-button"
              >
                <Calendar size={20} strokeWidth={1.5} />
                Book Appointment
              </button>

              {/* Call Button */}
              <a
                href={`tel:${location.phoneRaw}`}
                className="flex items-center justify-center gap-3 border border-white/30 text-white px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium hover:border-[#B8860B] hover:text-[#B8860B] transition-colors"
              >
                <Phone size={20} strokeWidth={1.5} />
                Call Now
              </a>
            </div>
          </div>
        </section>
      </div>

      {/* Booking Form Modal */}
      {showBookingForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
          <div className="bg-white w-full max-w-lg p-8 relative max-h-[90vh] overflow-y-auto rounded-lg shadow-2xl" data-testid="booking-form-modal">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-black/50 hover:text-black text-2xl font-light"
            >
              ×
            </button>

            <h2 className="text-black text-2xl font-light tracking-wide mb-2">Book Appointment</h2>
            <p className="text-black/60 text-sm mb-8">{location.name} – {location.branch}</p>

            {/* Success State */}
            {bookingResult?.success ? (
              <div className="text-center py-8">
                <CheckCircle size={64} className="mx-auto text-green-500 mb-4" />
                <h3 className="text-green-600 text-xl font-medium mb-2">Booking Confirmed!</h3>
                <p className="text-black/70 mb-4">{bookingResult.message}</p>
                {bookingResult.appointmentId && (
                  <p className="text-black/50 text-sm">Appointment ID: {bookingResult.appointmentId}</p>
                )}
                <button
                  onClick={closeModal}
                  className="mt-6 bg-[#B8860B] text-black px-8 py-3 text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#9A7B0A] transition-colors"
                >
                  Close
                </button>
              </div>
            ) : bookingResult?.success === false ? (
              /* Error State */
              <div className="text-center py-8">
                <AlertCircle size={64} className="mx-auto text-red-500 mb-4" />
                <h3 className="text-red-600 text-xl font-medium mb-2">Booking Failed</h3>
                <p className="text-black/70 mb-4">{bookingResult.message}</p>
                <button
                  onClick={() => setBookingResult(null)}
                  className="mt-6 bg-[#B8860B] text-black px-8 py-3 text-sm tracking-[0.15em] uppercase font-medium hover:bg-[#9A7B0A] transition-colors"
                >
                  Try Again
                </button>
              </div>
            ) : (
              /* Form */
              <form onSubmit={handleSubmit} className="space-y-5">
                {/* Name */}
                <div>
                  <label className="block text-black/50 text-[10px] tracking-[0.15em] uppercase mb-2">
                    <User size={14} className="inline mr-2" />
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your name"
                    className="w-full bg-gray-50 border border-gray-200 rounded px-4 py-3 text-black text-sm font-light focus:outline-none focus:border-[#B8860B] focus:ring-1 focus:ring-[#B8860B] transition-colors"
                  />
                </div>

                {/* Phone */}
                <div>
                  <label className="block text-black/50 text-[10px] tracking-[0.15em] uppercase mb-2">
                    <Phone size={14} className="inline mr-2" />
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your phone number"
                    className="w-full bg-gray-50 border border-gray-200 rounded px-4 py-3 text-black text-sm font-light focus:outline-none focus:border-[#B8860B] focus:ring-1 focus:ring-[#B8860B] transition-colors"
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block text-black/50 text-[10px] tracking-[0.15em] uppercase mb-2">
                    <Mail size={14} className="inline mr-2" />
                    Email Address (Optional)
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter your email"
                    className="w-full bg-gray-50 border border-gray-200 rounded px-4 py-3 text-black text-sm font-light focus:outline-none focus:border-[#B8860B] focus:ring-1 focus:ring-[#B8860B] transition-colors"
                  />
                </div>

                {/* Staff Selection - REQUIRED */}
                <div>
                  <label className="block text-black/50 text-[10px] tracking-[0.15em] uppercase mb-2">
                    Select Staff *
                  </label>
                  <div className="relative">
                    <select
                      name="staff_id"
                      value={formData.staff_id}
                      onChange={handleInputChange}
                      required
                      disabled={loadingStaff}
                      className="w-full bg-gray-50 border border-gray-200 rounded px-4 py-3 text-black text-sm font-light focus:outline-none focus:border-[#B8860B] focus:ring-1 focus:ring-[#B8860B] transition-colors cursor-pointer appearance-none"
                    >
                      <option value="">
                        {loadingStaff 
                          ? 'Loading staff...' 
                          : staffList.length === 0 
                            ? 'No staff available'
                            : 'Select Staff'}
                      </option>
                      {staffList.map((staff) => (
                        <option key={staff.id || staff._id} value={staff.id || staff._id}>
                          {staff.name}
                        </option>
                      ))}
                    </select>
                    {loadingStaff && (
                      <Loader2 size={16} className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-gray-400" />
                    )}
                  </div>
                  {!loadingStaff && staffList.length === 0 && (
                    <p className="text-red-500 text-xs mt-1">No staff available at this location.</p>
                  )}
                </div>

                {/* Date */}
                <div>
                  <label className="block text-black/50 text-[10px] tracking-[0.15em] uppercase mb-2">
                    <Calendar size={14} className="inline mr-2" />
                    Preferred Date *
                  </label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                    min={getTodayDate()}
                    className="w-full bg-gray-50 border border-gray-200 rounded px-4 py-3 text-black text-sm font-light focus:outline-none focus:border-[#B8860B] focus:ring-1 focus:ring-[#B8860B] transition-colors"
                  />
                </div>

                {/* Time */}
                <div>
                  <label className="block text-black/50 text-[10px] tracking-[0.15em] uppercase mb-2">
                    <Clock size={14} className="inline mr-2" />
                    Preferred Time *
                  </label>
                  <div className="relative">
                    <select
                      name="time"
                      value={formData.time}
                      onChange={handleInputChange}
                      required
                      disabled={!formData.date || loadingSlots}
                      className="w-full bg-gray-50 border border-gray-200 rounded px-4 py-3 text-black text-sm font-light focus:outline-none focus:border-[#B8860B] focus:ring-1 focus:ring-[#B8860B] transition-colors cursor-pointer appearance-none disabled:bg-gray-100 disabled:text-gray-400"
                    >
                      <option value="">
                        {!formData.date 
                          ? 'Select a date first' 
                          : loadingSlots 
                            ? 'Loading available slots...' 
                            : availableSlots.length === 0 
                              ? 'No slots available' 
                              : 'Select Time'}
                      </option>
                      {availableSlots.map((slot) => (
                        <option key={slot} value={slot}>
                          {slot}
                        </option>
                      ))}
                    </select>
                    {loadingSlots && (
                      <Loader2 size={16} className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-gray-400" />
                    )}
                  </div>
                  {formData.date && !loadingSlots && availableSlots.length === 0 && (
                    <p className="text-red-500 text-xs mt-1">No slots available for this date. Please select another date.</p>
                  )}
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={submitting || !formData.name || !formData.phone || !formData.staff_id || !formData.date || !formData.time}
                  className="w-full bg-[#B8860B] text-black py-4 text-sm tracking-[0.2em] uppercase font-medium hover:bg-[#9A7B0A] transition-colors mt-6 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {submitting ? (
                    <>
                      <Loader2 size={18} className="animate-spin" />
                      Booking...
                    </>
                  ) : (
                    'Confirm Booking'
                  )}
                </button>

                <p className="text-black/40 text-xs text-center mt-4">
                  Your appointment will be confirmed instantly
                </p>
              </form>
            )}
          </div>
        </div>
      )}
    </main>
    </>
  );
};

export default LocationDetail;
